import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { CoreSharedModule } from '@vendasta/shared';
import { VaOrderFormModule, VaOrderSummaryModule } from '@vendasta/store';
import { VaIconModule } from '@vendasta/uikit';
import baseTranslation from '../../assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from '../../shared/constants';
import { SalesOpportunityStoreService } from '../sales-opportunity-store.service';
import { SalesOrderLineItemSelectorModule } from '../sales-order-line-item-selector/sales-order-line-item-selector.module';
import { SalesOrderStoreService } from '../sales-order-store.service';
import { SalesOrderConfirmationComponent } from './sales-order-confirmation.component';
import { SalesOrderEditPriceComponent } from './sales-order-edit-price/sales-order-edit-price.component';
import { SalesOrderLineItemSelectorDialogComponent } from './sales-order-line-item-selector-dialog/sales-order-line-item-selector-dialog.component';

@NgModule({
  declarations: [
    SalesOrderConfirmationComponent,
    SalesOrderEditPriceComponent,
    SalesOrderLineItemSelectorDialogComponent,
  ],
  exports: [SalesOrderConfirmationComponent, SalesOrderLineItemSelectorDialogComponent],
  imports: [
    CommonModule,
    VaOrderFormModule,
    VaOrderSummaryModule,
    MatButtonModule,
    MatListModule,
    VaIconModule,
    CoreSharedModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    FormsModule,
    MatTooltipModule,
    MatInputModule,
    MatCheckboxModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    SalesOrderLineItemSelectorModule,
    MatCardModule,
    MatGridListModule,
    MatAutocompleteModule,
    MatMenuModule,
  ],
  providers: [CurrencyPipe, SalesOrderStoreService, SalesOpportunityStoreService],
})
export class SalesOrderConfirmationModule {}
